import React, { useState } from 'react';
import { BrowserRouter as Router, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import LoginForm from './components/Auth/LoginForm';
import Sidebar from './components/Layout/Sidebar';
import HomePage from './pages/Home/HomePage';
import ClientiPage from './pages/Clienti/ClientiPage';
import OficiuPage from './pages/Oficii/OficiuPage';
import FacturarePage from './pages/Facturare/FacturarePage';
import TermenePage from './pages/Litigii/TermenePage';
import CalendarPage from './pages/Calendar/CalendarPage';
import MandatariPage from './pages/Mandatari/MandatariPage';
import ReinnouriPage from './pages/Reinnoiri/ReinnouriPage';
import RapoartePage from './pages/Rapoarte/RapoartePage';
import PontajPage from './pages/Pontaj/PontajPage';
import PontajAngajatiPage from './pages/Pontaj/PontajAngajatiPage';
import { PONTAJ_ENABLED } from './config/features';
import './App.css';

function PublicRoute({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return children;
}

function ProtectedLayout() {
  const { user } = useAuth();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="app-shell">
      {!mobileSidebarOpen && (
        <button
          className="mobile-ham"
          type="button"
          onClick={() => setMobileSidebarOpen(true)}
          aria-label="Deschide meniu"
        >
          <span /><span /><span />
        </button>
      )}
      <Sidebar mobileOpen={mobileSidebarOpen} onMobileClose={() => setMobileSidebarOpen(false)} />
      <Outlet />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginForm /></PublicRoute>} />
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/clienti" element={<ClientiPage />} />
            <Route path="/oficii/osim"    element={<OficiuPage title="OSIM"    tips={['marca_osim','dmi','brevet']}      icon="🏛️" />} />
            <Route path="/oficii/euipo"   element={<OficiuPage title="EUIPO"   tips={['marca_euipo','dmi']}              icon="🇪🇺" />} />
            <Route path="/oficii/wipo"    element={<OficiuPage title="WIPO"    tips={['marca_wipo','dmi']}               icon="🌐" />} />
            <Route path="/oficii/epo"     element={<OficiuPage title="EPO"     tips={['brevet']}                         icon="💡" />} />
            <Route path="/oficii/benelux"         element={<OficiuPage title="Benelux"              tips={['idepot']}                icon="🏛️" />} />
            <Route path="/oficii/internationala"  element={<OficiuPage title="Marci Internationale" tips={['marca_internationala']} icon="🏳️" />} />
            <Route path="/oficii/instanta" element={<Navigate to="/litigii/dosare" replace />} />
            <Route path="/litigii/dosare"  element={<OficiuPage title="Dosare" tips={['dosar_instanta','opozitie_osim','opozitie_euipo','contestatie_osim','cai_atac_euipo','notificare_aviz']} icon="⚖️" />} />
            <Route path="/litigii/termene" element={<TermenePage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            {PONTAJ_ENABLED && <Route path="/pontaj" element={<PontajPage />} />}
            {PONTAJ_ENABLED && <Route path="/pontaj-angajati" element={<PontajAngajatiPage />} />}
            <Route path="/facturare" element={<FacturarePage />} />
            <Route path="/mandatari" element={<MandatariPage />} />
            <Route path="/reinnoiri" element={<ReinnouriPage />} />
            <Route path="/rapoarte" element={<RapoartePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
